import { useIsFetching } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { Loader } from '@/components/Loader/Loader.tsx';
import { appRoutes } from '@/routes/app-routes.ts';
import { useAuthStore } from '@/store';

interface IProtectedRouteProps {
    children?: ReactNode;
}

export const ProtectedRoute = ({ children }: IProtectedRouteProps) => {
    const { isAuth, token } = useAuthStore();
    const isUserDataFetching = useIsFetching({ queryKey: ['user'] });

    const redirect = token ? <Loader fullScreen /> : <Navigate to={appRoutes.mainPage} />;
    const loadingChildren = (
        <>
            {children}
            {isUserDataFetching > 0 && <Loader fullScreen />}
        </>
    );

    return isAuth ? loadingChildren : redirect;
};
